import { mediaUrl } from "@/lib/api";

/** Displays a media image by id, or a neutral gray placeholder when absent. */
export default function MediaImage({ id, thumb = false, alt = "", className = "", aspect = "aspect-[4/5]", testId }) {
  if (!id) {
    return (
      <div
        data-testid={testId}
        className={`ph bg-[#F3E7D2] ${aspect} ${className}`}
        role="img"
        aria-label={alt || "Platzhalter"}
      />
    );
  }
  return (
    <img
      data-testid={testId}
      src={mediaUrl(id, thumb)}
      alt={alt}
      loading="lazy"
      className={`object-cover ${aspect} ${className}`}
    />
  );
}
